import { render } from "./RolesView.vue?vue&type=template&id=65d68464&scoped=true&ts=true"
import script from "./RolesView.vue?vue&type=script&lang=ts"
export * from "./RolesView.vue?vue&type=script&lang=ts"

import "./RolesView.vue?vue&type=style&index=0&id=65d68464&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d68464"]])

export default __exports__